import styled from 'styled-components';
import { spacing, colors, Body2Bold, Caption } from 'ui/theme';

export const Wrapper = styled.div`
  display: grid;
  gap: ${spacing.base};
  padding: ${spacing.plusHalf};
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: ${spacing.half};
`;

export const Body2BoldNoMargin = styled(Body2Bold)`
  margin-bottom: 0;
`;

export const CaptionLight = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const Left = styled.div`
  align-self: start;
  gap: ${spacing.quarter};
`;

export const InlineFlex = styled.div`
  align-items: center;
  column-gap: ${spacing.quarter};
  display: inline-flex;
  flex-wrap: wrap;
`;

export const FlexWrapWithGap = styled.div`
  align-items: center;
  display: flex;
  justify-content: start;
  gap: ${spacing.half};
  flex-wrap: wrap;
`;
